// extracted by mini-css-extract-plugin
export default {"tags":"UpdateReportTags_tags__JorU-","tagsSelect":"UpdateReportTags_tagsSelect__byXkC"};